import { createFileRoute } from '@tanstack/react-router'
import { guardAdminOnly } from '@/lib/auth/routeGuards'
import {
  LayoutDashboard,
  Users,
  BookOpen,
  GraduationCap,
  UserCheck,
  Calculator,
  Settings,
  CreditCard,
} from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import AdminService from '@/components/adminPage/AdminService'
import ClassManagement from '@/components/adminPage/etablissment/ClassManagment'
import UserManagement from '@/components/adminPage/UserManagement'
import TeacherManagement from '@/components/adminPage/teacher/TeacherManagement'
import StudentManagement from '@/components/adminPage/student/StudentManagement'
import ListEliminate from '@/components/adminPage/student/ListEliminate'
import CalculateStudentScore from '@/components/adminPage/student/CalculateStudentScore'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/admin/')({
  component: AdminLayout,
  beforeLoad: guardAdminOnly,
})

function AdminLayout() {
  const { t } = useTranslation()
  const currentPage = t('routes.admin-folder.index.navigation.adminService')

  const getNavigationItems = () => [
    {
      name: t('routes.admin-folder.index.navigation.adminService'),
      icon: LayoutDashboard,
      component: AdminService,
    },
    {
      name: t('routes.admin-folder.index.navigation.classManagement'),
      icon: BookOpen,
      component: ClassManagement,
    },
    {
      name: t('routes.admin-folder.index.navigation.teacherManagement'),
      icon: Users,
      component: TeacherManagement,
    },
    {
      name: t('routes.admin-folder.index.navigation.studentManagement'),
      icon: GraduationCap,
      component: StudentManagement,
    },
    {
      name: t('routes.admin-folder.index.navigation.listEliminateStudent'),
      icon: UserCheck,
      component: ListEliminate,
    },
    {
      name: t('routes.admin-folder.index.navigation.calculateStudentScore'),
      icon: Calculator,
      component: CalculateStudentScore,
    },
    {
      name: t('routes.admin-folder.index.navigation.cardStudio'),
      icon: CreditCard,
      component: () =>
        (window.location.href = '/admin/establishment/card-studio'),
    },
    {
      name: t('routes.admin-folder.index.navigation.userManagement'),
      icon: Settings,
      component: UserManagement,
    },
  ]

  const renderContent = () => {
    const route = getNavigationItems().find((item) => item.name === currentPage)
    const Component = route?.component || AdminService
    return <Component />
  }

  return (
    <div className="flex min-h-screen w-[80%] m-auto">
      <main className="p-4 w-full sm:w-full md:w-10/12 lg:w-10/12 xl:w-10/12">
        <Card>
          <CardHeader>
            <CardTitle>{currentPage}</CardTitle>
          </CardHeader>
          <CardContent>{renderContent()}</CardContent>
        </Card>
      </main>
    </div>
  )
}
